/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CollectionSearchByTraitResponse } from '../models/CollectionSearchByTraitResponse';
import type { SearchAssetsWithinCollectionByTraitsInput } from '../models/SearchAssetsWithinCollectionByTraitsInput';
import type { SearchResults } from '../models/SearchResults';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SearchService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * NFT search
     * Searches for an NFT asset or collection based on an input query
     * @returns SearchResults OK
     * @throws ApiError
     */
    public getSearchResults({
        network = 'ethereum-mainnet',
        limit,
        offset,
        query,
        type,
    }: {
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
        limit?: number | null,
        offset?: number | null,
        /** Query string **/
        query?: string,
        /** Desired result type, valid options are asset, collection, or all **/
        type?: string,
    }): CancelablePromise<SearchResults> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/search',
            path: {
                'network': network,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'query': query,
                'type': type,
            },
            errors: {
                400: `Validation Error`,
            },
        });
    }

    /**
     * Search assets within a collection by traits
     * Returns all assets within a collection with particular attributes
     * @returns CollectionSearchByTraitResponse OK
     * @throws ApiError
     */
    public searchAssetsWithinCollectionByTraits({
        address = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        network = 'ethereum-mainnet',
        limit,
        offset,
        requestBody,
    }: {
        /** Collection Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
        limit?: number | null,
        offset?: number | null,
        requestBody?: SearchAssetsWithinCollectionByTraitsInput,
    }): CancelablePromise<CollectionSearchByTraitResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/{network}/{address}/assets/searchByTraits',
            path: {
                'address': address,
                'network': network,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
            },
        });
    }

}